import { Language } from '../translations'

export const projectHistoryTranslations: Record<string, Record<Language, string>> = {
  projectName: {
    en: 'Project',
    fi: 'Projekti'
  },
  role: {
    en: 'Role',
    fi: 'Rooli'
  },
  addProject: {
    en: 'Add Project',
    fi: 'Lisää projekti'
  },
  editProject: {
    en: 'Edit Project',
    fi: 'Muokkaa projektia'
  },
  noProjectHistory: {
    en: 'No project history entries',
    fi: 'Ei projektihistoriatietoja'
  },
  projectHistoryAdded: {
    en: 'Project history added successfully',
    fi: 'Projekti lisätty onnistuneesti'
  },
  projectHistoryUpdated: {
    en: 'Project history updated successfully',
    fi: 'Projekti päivitetty onnistuneesti'
  },
  projectHistoryDeleted: {
    en: 'Project history deleted successfully',
    fi: 'Projekti poistettu onnistuneesti'
  },
  confirmDeleteProjectHistory: { en: "Are you sure you want to delete this project?", fi: "Haluatko varmasti poistaa tämän projektin?" },
  notSpecified: {
    en: 'Not specified',
    fi: 'Ei määritelty'
  },
  companyName: {
    en: 'Company',
    fi: 'Loppuasiakas'
  },
  technologies: {
    en: 'Technologies',
    fi: 'Teknologiat'
  },
  technologiesPlaceholder: {
    en: 'e.g. React, Node.js, PostgreSQL',
    fi: 'esim. React, Node.js, PostgreSQL'
  },
  companyConfidential: {
    en: 'Company Confidential',
    fi: 'Yritys luottamuksellinen'
  },
  setCompanyConfidential: {
    en: 'Set company name to be confidential',
    fi: 'Merkitse loppuasiakkaan nimi luottamukselliseksi'
  },
  selectRole: {
    en: 'Select role',
    fi: 'Valitse rooli'
  },
  pleaseSelectValidRole: {
    en: 'Please select a valid role from the list',
    fi: 'Valitse kelvollinen rooli listalta'
  }
};
